import {ActivatedRouteSnapshot} from '@angular/router';

export const findParam = (routeSnapshot: ActivatedRouteSnapshot, paramName) => {
    const targetRoute = routeSnapshot.pathFromRoot.find(route => route.params.hasOwnProperty(paramName));
    return targetRoute ? targetRoute.params[paramName] : undefined;
};
